<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-12-15 16:55:04
 * @LastEditTime: 2022-03-10 14:56:56
-->
<template>
  <div class="alarm-table">
    <el-table size="mini" id="out-table" :data="historyAlarmList" row-key="id"
      :header-cell-style="{ background: '#e4f1ff' }" height="400" style="min-width:600px;">
      <el-table-column :label="$t('lang.alarmNotice.device')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.dname
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.terminal')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.dtuname
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.variable')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.vname
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" :label="$t('lang.alarmNotice.information1')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.alarmContent
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" :label="$t('lang.alarmNotice.information2')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.recoverContent
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" :label="$t('lang.alarmNotice.triggering')">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.rule
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.alarmStartTime')" width="150px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.sts | formateTime
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmNotice.alarmEndTime')" width="150px">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.ets | formateTime
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="historyAlarmTotal" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import { PublicComponent } from "@/mixins/common.js";
import { getByDevice } from "@/api/cloudMonitor/terminalList";
import { getHistoryAlarm, getHistoryAlarmAll } from "@/api/cloudMonitor/historyAlarm";
import moment from "moment";
export default {
  mixins: [PublicComponent],
  props: ["searchData", "deviceItem"],
  // props: ['historyAlarmList', 'historyAlarmTotal'],
  data() {
    return {
      limit: 10,
      offset: 1,
      historyAlarmTotal: 0,
      historyAlarmList: [],
    };
  },
  components: {
    pagination,
  },
  filters: {
    formateTime(time) {
      if (time) {
        return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.queryKeyword();
  },
  methods: {
    queryKeyword() {
      if (this.searchData.dtuid && this.searchData.vid) {
        let params = {
          current: this.offset,
          size: this.limit,
          dtuid: this.searchData.dtuid,
          did: this.deviceItem.deviceDid,
          vid: this.searchData.vid,
          sts: moment(this.searchData.time[0]).format("YYYY-MM-DD HH:mm:ss"),
          ets: moment(this.searchData.time[1]).format("YYYY-MM-DD HH:mm:ss"),
        };
        getHistoryAlarm(params).then((res) => {
          if (res.data.code === 0) {
            this.historyAlarmList = res.data.data.records;
            this.historyAlarmTotal = res.data.data.total;
          }
        });
      }
    },
    exportData() {
      return new Promise((reslove, reject) => {
        if (this.searchData.dtuid && this.searchData.vid) {
          let params = {
            current: this.offset,
            size: this.limit,
            dtuid: this.searchData.dtuid,
            did: this.deviceItem.deviceDid,
            vid: this.searchData.vid,
            sts: moment(this.searchData.time[0]).format("YYYY-MM-DD HH:mm:ss"),
            ets: moment(this.searchData.time[1]).format("YYYY-MM-DD HH:mm:ss"),
          };
          getHistoryAlarmAll(params).then((res) => {
            if (res.data.code === 0) {
              this.historyAlarmList = res.data.data;
              reslove()
            }
            reject()
          }).cathc(err => {
            reject(err)
          })
        }
      })
    }
  },
  watch: {
    "searchData.dtuid": {
      handler(newV) {
        console.log(newV);
        if (newV) {
          this.queryKeyword();
        }
      },
      deep: true,
    },
    "searchData.vid": {
      handler(newV) {
        console.log(newV);
        if (newV) {
          this.queryKeyword();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.font-style {
  font-size: 0.25rem;
}
</style>
